export default "__VITE_ASSET__56eae4eb__"